import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "button",
        {
          staticClass: "text-body-2 link-decoration-none primary--text ml-10",
          on: {
            click: function ($event) {
              _setup.isOpened = true
            },
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_setup.t("Смотреть фото", _setup.l10nOptions)) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(_setup.CoreDialog, {
        attrs: {
          title: _setup.t("Фото", _setup.l10nOptions),
          divider: "",
          size: _setup.isMobile ? "fullscreen" : "xl",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "prependBtn",
              fn: function ({ btnProps }) {
                return [
                  _c(
                    VBtn,
                    _vm._b(
                      {
                        on: {
                          click: function ($event) {
                            _setup.isOpened = false
                          },
                        },
                      },
                      "v-btn",
                      btnProps,
                      false
                    ),
                    [_c("span", { staticClass: "ui-icon-close-not-a-circle" })]
                  ),
                ]
              },
            },
            {
              key: "default",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "b-swiper lpu-access-gallery",
                      class: _setup.isMobile ? "w-100 py-10" : "mx-n4",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "b-swiper__track" },
                        _vm._l(_vm.images, function (image, i) {
                          return _c(
                            "div",
                            { key: i, staticClass: "b-swiper__slide w-100" },
                            [
                              _c(VImg, {
                                attrs: {
                                  contain: "",
                                  "aspect-ratio": _setup.isMobile ? 1 : 3 / 2,
                                  src: image,
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            !_setup.isMobile
              ? {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        VBtn,
                        {
                          attrs: { text: "", depressed: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              _setup.isOpened = false
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_setup.t("Закрыть", _setup.l10nOptions)) +
                              "\n      "
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
        model: {
          value: _setup.isOpened,
          callback: function ($$v) {
            _setup.isOpened = $$v
          },
          expression: "isOpened",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }